import { apiClient } from "api/apiClient";
import React, { useEffect } from "react";
import ReactMarkdown from "react-markdown";
import Box from "ReusableComponents/Box";
import Text from "ReusableComponents/Text";
import H2 from "ReusableComponents/Text/H2";
import { COLORS, SIZES } from "theme";

const SavingSection = ({ small, data, savingTitle }) => {
  return (
    <Box
      textAlign={small ? "start" : "center"}
      display="flex"
      flexDirection="column"
      padding={small ? "40px 20px" : 0}
    >
      <H2
        textColor="white"
        fontWeight="bold"
        margin="0px 20px"
        fontSize={small ? SIZES.twenty : "40px"}
      >
        {savingTitle?.attributes?.title}
      </H2>
      <Box
        display="flex"
        justifyContent="space-between"
        margin="24px auto"
        width={small ? "100%" : "1060px"}
        flexDirection={small ? "column" : "row"}
      >
        {data?.map((item, index) => (
          <Box
            key={index}
            display="flex"
            flexDirection={"column"}
            bgc="white"
            padding="20px"
            margin="20px"
            width={small ? "100%" : "48%"}
            boxShadow="0 4px 8px rgba(0, 0, 0, 0.1)"
            alignItems="center"
          >
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              backgroundColor="#fff"
              padding="20px"
              borderRadius="8px"
              marginBottom={small ? "20px" : 0}
              marginRight={small ? 0 : "20px"}
              flex="1"
            >
              <img
                src={item?.attributes?.image?.data?.attributes?.url}
                alt={item?.attributes?.image?.data?.attributes?.alternativeText}
                style={{
                  width: "100%",
                  maxWidth: "150px", // Make the image smaller
                  objectFit: "contain",
                }}
              />
            </Box>
            <Box flex="2" textAlign="left">
              <Text
                fontSize="24px"
                fontWeight="bold"
                color="#000"
                marginBottom="10px"
                textAlign="left"
              >
                {item?.attributes?.title}
              </Text>
              <Text
                fontSize="18px"
                color="#333"
                marginBottom="10px"
                textAlign="left"
              >
                <ReactMarkdown children={item?.attributes?.description} />
              </Text>
              <Text
                fontSize="22px"
                color="#00A651"
                marginBottom="20px"
                textAlign="left"
              >
                {item?.attributes?.price}
              </Text>
              <a
                href={item?.attributes?.URL || "#"} // Fallback to "#" if URL is not provided

                style={{
                  padding: "10px 20px",
                  fontSize: "16px",
                  backgroundColor: COLORS.primary,
                  border: "none",
                  fontFamily: "Archia",
                  borderRadius: "5px",
                  color: "black",
                  cursor: "pointer",
                  textAlign: "left",
                }}
              >
                View Details
              </a>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default SavingSection;
